module.exports = {
      id: "hamburger-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite.svg#hamburger",
      toString: function () {
        return this.url;
      }
    }